window.addEventListener("load", function () {
  if ($("#swiperFeature").length > 0) {
    const mainSwiper = new Swiper("#swiperFeature", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      loop: true,
      touchStartPreventDefault: false,
      //   autoplay: {
      //     delay: 3000,
      //     disableOnInteraction: false,
      //   },
      pagination: {
        el: ".swiper-feature-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-feature-button-next",
        prevEl: ".swiper-feature-button-prev",
      },
    });
  }
});
